module.exports = __webpack_public_path__ + "static/media/refresh.3a09db69.svg";